<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h2 class="fm_title"><span class="bold">Preface</span></h2>
<p class="indenta">In August 1914 I embarked unexpectedly on the uncharted and uncertain venture of taking part in a twentieth-century war.</p>
<p class="indent">This is a factual account of my own experiences following enlistment on the outbreak of the war in an R.E. Field Company of the 48th South Midland (Territorial) Division. It covers the whole war period of the Division from mobilization, including four years’ service overseas in Belgium, France and Italy.</p>
<p class="indent">Despite the personal nature of my story, it is hoped that it will convey a more general understanding and portrayal of the role and tasks undertaken by the R.E. Field Companies, and of the conditions in which they worked, both in the trench warfare and major battles.</p>
<p class="indent">The narrative is extracted to a large extent from my letters, diaries and other records <em class="italic">as written at the time</em>, and I have retained the original wording, however unpolished. It will be evident, also, that the views and reactions expressed in the earlier days of the war underwent very considerable changes as the number and intensity of the weapons employed increased.</p>
<p class="indent">For the blatant egotism of the narrative I can only recall in my defence Carlyle’s words, “Every mortal is a microcosm; but to himself a macrocosm. Universal Nature would barely hold what he could say about himself.”</p>
<p class="indent">Finally, I should like to thank my friend Charles Carrington, who encouraged me to quote from his book <em class="italic">Soldier from the War Returning.</em></p>
<p class="right"><em class="italic">V. F. EBERLE</em></p>
<a id="page_vi"></a>
<div class="img_container"><img alt="images" src="images/f0006-01.jpg"/>
<p class="caption"><em class="italic">Before the Somme Battle, 1916</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Preface.vue?07ee96e5